import axiosInstance from "../axiosClient";
import { platformAnalytics, userAnalytics, consultantAnalytics } from "../config";

const isValidDate = (date) => /^\d{4}-\d{2}-\d{2}$/.test(date);

export const getPlatformAnalytics = async (date) => {
  let queryParams = [];
  if (date && isValidDate(date)) queryParams.push(`date=${encodeURIComponent(date)}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return await axiosInstance.get(`${platformAnalytics}${queryString}`);
};

export const getUserAnalytics = async (user_id, date) => {
  let queryParams = [];
  if (user_id) queryParams.push(`user_id=${encodeURIComponent(user_id)}`);
  if (date && isValidDate(date)) queryParams.push(`date=${encodeURIComponent(date)}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return await axiosInstance.get(`${userAnalytics}${queryString}`);
};

export const getConsultantAnalytics = async (consultant_id, date) => {
  let queryParams = [];
  if (consultant_id) queryParams.push(`consultant_id=${encodeURIComponent(consultant_id)}`);
  if (date && isValidDate(date)) queryParams.push(`date=${encodeURIComponent(date)}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return await axiosInstance.get(`${consultantAnalytics}${queryString}`);
};
